export const resetPasswordResourceType = 'reset_password_request';
export const resetPasswordResourcePath = '/reset_password';
